import request from "@/utils/request";

export function getServices() {
  return request({
    url: "services",
  });
}

export function getTechnician(storeName) {
  return request({
    url: `user/assignee?store_name=${storeName}`,
  });
}

export function createTicket(body) {
  return request({
    url: "ticket",
    method: "post",
    data: body,
  });
}

export const getDisplayName = (storeName) => {
  return request({
    url: `store/infor?store_name=${storeName}`,
    method: "get",
  });
};

export const requestVerificationCode = (data) => {
  return request({
    url: `user/verify/phone_number`,
    method: "post",
    data,
  });
};

export const verifyCode = (data) => {
  return request({
    url: `user/verify/otp`,
    method: "post",
    data,
  });
};

export const findCustomer = (phone, storeName) => {
  return request({
    url: `user/customer/${phone}?store_name=${storeName}`,
    method: "get",
  });
};

export function findOrderId(params) {
  return request({
    url: "ticket/count/last-order-id",
    method: "get",
    params,
  });
}

export function getStoreSettings(storeName) {
  return request({
    url: `store/settings?store_name=${storeName}`,
    method: "get",
  });
}

export function findTicketById(id) {
  return request({
    url: `/ticket/${id}/review`,
    method: "get",
  });
}

export function addReview(data) {
  return request({
    url: `/review`,
    method: "post",
    data,
  });
}
